import React from "react";
import { PublicView } from "pages/public";
import { useAppStore } from "store/index";
import { PrivateView } from "pages/private";
import { observer, Provider } from "mobx-react";
import { initAxios, setAuthHeaders } from "api/baseApi";
import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { LayerHost, ThemeProvider } from "@fluentui/react";
import { bodyTheme } from "configs/themeGenerator";
import { AuthApi } from "@api/authApi";
import { extractErrorMessage, toErrorMessageBar } from "@helpers/alertUtils";

export interface IErrorMessageProps {
  message: string;
  resetChoice?: () => void;
}

function App(): React.JSX.Element {
  const store = useAppStore();
  const { accountStore } = store;
  const [axiosInitialized, setAxiosInitialized] = useState<boolean>(false);
  const [isLoaded, setOnLoad] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  useEffect(() => {
    initAxios((error: AxiosError) => {
      if (error && error.response?.status === 401 && !error.config?.url?.includes("auth/signout")) {
        accountStore.signOut();
      }
    });
    setAxiosInitialized(true);
  }, [accountStore]);

  if (accountStore.accessToken) {
    setAuthHeaders(accountStore.accessToken);
  }

  useEffect(() => {
    if (axiosInitialized && accountStore.accessToken) {
      // eslint-disable-next-line promise/catch-or-return
      AuthApi.getCurrentUser()
        .then((response) => {
          accountStore.setCurrentUser(response.data.data);
          return response.data.data;
        })
        .catch((e) => {
          setErrorMessage(extractErrorMessage(e));
        })
        .finally(() => {
          setOnLoad(true);
        });
    }
  }, [axiosInitialized, accountStore, accountStore.accessToken]);
  if (!axiosInitialized) return <></>;

  return (
    <ThemeProvider theme={bodyTheme} applyTo="body">
      <Provider store={store}>
        <BrowserRouter>
          {accountStore.isAuthenticated ? <PrivateView isLogin={isLoaded} /> : <PublicView />}
        </BrowserRouter>
        {errorMessage && toErrorMessageBar(errorMessage)}
        <LayerHost id="custom-layer-host" style={{ position: "fixed", top: 0, left: 0, width: "100%" }} />
      </Provider>
    </ThemeProvider>
  );
}

export default observer(App);
